export default {
  name: 'disabledStyle',
  items: [{
    name: 'backgroundImage',
    text: '背景图',
    type: 'upload',
    drag: true,
  }, {
    type: 'row',
    span: 12,
    items: [{
      name: 'backgroundColor',
      text: '背景颜色',
      type: 'colorPicker',
    }, {
      name: 'backgroundRepeat',
      text: '背景图重复',
      type: 'hidden',
      options: [
        { text: 'repeat', value: 'repeat' },
        { text: 'repeat-x', value: 'repeat-x' },
        { text: 'repeat-y', value: 'repeat-y' },
        { text: 'no-repeat', value: 'no-repeat' },
        { text: 'inherit', value: 'inherit' },
      ],
    }],
  }, {
    name: 'backgroundSize',
    text: '背景图大小',
    type: 'hidden',
  }],
};
